export function getAreaFromVehicleId(vehicleId: string | undefined): string {
  if (!vehicleId) return 'Unknown';
  const parts = vehicleId.split('::');
  return parts.length >= 2 ? (parts[1] ?? 'Unknown') : 'Unknown';
}
